'use strict';

import { newModalFromString } from './components/modal';
import { appendToUrl } from './util/common';
import Plugins from 'util/plugins';
import FindInStore from './product/findinstore';
import { initProductTile } from './productTileComponent/productTile';
import { getFormatSku } from './analytics/helpers/helper';
import { applyRendering } from './util/render';

function throttle (func, delay) {
    let time = 0;
    let trailingTimeout = null;

    return function (...args) {
        const now = Date.now();
        const remaining = delay - (now - time);

        if (remaining <= 0) {
            if (trailingTimeout) {
                clearTimeout(trailingTimeout);
                trailingTimeout = null;
            }
            time = now;
            func.apply(this, args);
        } else if (!trailingTimeout) {
            trailingTimeout = setTimeout(() => {
                trailingTimeout = null;
                time = Date.now();
                func.apply(this, args);
            }, remaining);
        }
    };
}

class OrderAgain {
    constructor () {
        this.className = '.js-orderAgain';
        this.classCarousel = '.js-orderAgain-carousel';
        this.classCarouselItem = '.js-orderAgain-carousel__item';
        this.classSeeSimilarItem = '.js-orderAgain-carousel__seeSimilarItem';
        this.classModalColors = '.js-orderAgain-modal__colorSwatch-link';
        this.classModalSizes = '.js-orderAgain-modal__sizeOption-link';
        this.classAddToCartButton = '.js-orderAgain-modal__addToCartButton';
        this.classQuantityInput = '.js-orderAgain-modal__quantitySelector';
        this.orderAgainCarouselContainerSelector = '.js-orderAgain-carousel__container';
        this.customPrevSelector = '.js-custom-prev';
        this.customNextSelector = '.js-custom-next';
        this.classOrderDetailsItem = '.js-orderAgain-orderDetails__item';
        this.classOrderDetailsItemMobile = '.js-orderAgain-orderDetails__itemMobile';
        this.classBuyAgainPage = '.js-orderAgain-showPage';
        this.classFilterSelect = '.js-orderAgain-filter__select';
        this.classProductsContainer = '.js-orderAgain-page__productsContainer';
        this.classRecommendations = '.js-orderAgain-recommendations__container';
        this.classCartTab = '.js-orderAgain-cartTab__container';
        this.classCartTabItemLink = '.js-orderAgain-cartTab__item-link';
        this.classProductDetails = '.js-orderAgain-productDetails__label';
        this.viewportCarouselContainerSelector = '.cc-orderAgain-page__carouselContainer > .js-orderAgain-carousel.cc-orderAgain-carousel';
        this.modalTitleIdPrefix = 'orderAgainModalTitle';
        this.modalTitleCounter = 0;

        this.isCarouselListenersLoaded = false;
        this.filterModal = null;

        this.nativeScrollClass = '.orderAgainNative';
        this.nativeScrollActive = false;
        this.nativeScrollResizeTimer = null;
        this._nativePrevHandler = null;
        this._nativeNextHandler = null;
        this._nativeScrollHandler = null;
        this.nativeScrollMonitorInitialized = false;
        this._evaluateNativeMode = null;
        this.$nativeCarouselContainer = null;
        this.$nativePrevArrow = null;
        this.$nativeNextArrow = null;
        this.carouselResizeMonitorInitialized = false;
        this.carouselResizeTimer = null;
        this.carouselMode = null;
        this.carouselDataUrl = null;
        this.findInStoreInitialized = false;
    }

    run () {
        if ($(this.className).length) {
            const carouselUrl = $(this.className).data('url');
            if (carouselUrl) {
                this.carouselDataUrl = carouselUrl;
                const $carouselContainer = this._getCarouselContainer();
                if ($carouselContainer.length !== 0) {
                    this._loadCarouselOnViewportChange(carouselUrl, $carouselContainer);
                    this.addCarouselListeners();
                }
            }
        }

        if ($(this.classOrderDetailsItem).length) {
            const orderDetailsButtonUrl = $(this.classOrderDetailsItem).first().data('url');
            if (orderDetailsButtonUrl) {
                const $orderDetailsItems = $(this.classOrderDetailsItem);
                this.loadOrderDetailsButtons(orderDetailsButtonUrl, $orderDetailsItems);
                this.addCarouselListeners();
            }
        }

        const hasBuyAgainPage = $(this.classBuyAgainPage).length > 0;
        const hasCartTab = $(this.classCartTab).length > 0;

        if (hasBuyAgainPage || hasCartTab) {
            this.orderAgainPageListeners();
            this.orderAgainPageInfiniteScroll();
            this.addCarouselListeners();
            this.initFilterSelectionLabel();
        }

        if (hasBuyAgainPage) {
            this.loadRecommendationsCarousel();
        }

        if (hasCartTab) {
            const cartTabContainerUrl = $(this.classCartTab).data('url');
            if (cartTabContainerUrl) {
                this.showCartTab(cartTabContainerUrl);
            }
        }

        const $productDetailsContainer = $(this.classProductDetails);
        if ($productDetailsContainer.length) {
            const productDetailsUrl = $productDetailsContainer.data('url');
            if (productDetailsUrl) {
                this.addProductDetailsListeners($productDetailsContainer, productDetailsUrl);
            }
        }
    }

    loadCarousel (url, $carouselContainer) {
        $.ajax(url).then((data) => {
            this._separateScrollCarouselState($carouselContainer);
            $carouselContainer.html(data || '');
            this._initOrderItAgainCarousel();

            $('body').trigger('orderAgain:carouselLoaded');
        });
    }

    addCarouselListeners () {
        if (this.isCarouselListenersLoaded) {
            return;
        }
        this.isCarouselListenersLoaded = true;
        // Single combined selector to separate the order it again from the see similar modal.
        const modalTriggerSelector = [this.classCarouselItem, this.classSeeSimilarItem].join(', ');
        // Carousel item click listener
        $('body').on('click', modalTriggerSelector, (e) => {
            e.preventDefault();

            const $currentTarget = $(e.currentTarget);
            let url = $currentTarget.data('url');
            if (!url) {
                return;
            }

            const isSeeSimilarTrigger = $currentTarget.is(this.classSeeSimilarItem);

            this._openModalFromTrigger(url, $currentTarget, {
                modalClasses: isSeeSimilarTrigger
                    ? ['cc-orderAgain-seeSimilarModalWrapper', 'analytics-see-similar']
                    : ['cc-orderAgain-modal', 'analytics-order-again'],
                enableOrderAgainInteractions: !isSeeSimilarTrigger,
                afterOpen: (modal) => {
                    if (isSeeSimilarTrigger) {
                        initProductTile();
                    } else {
                        const target = $(modal.modalBox);
                        $('body').trigger('analytics:orderAgainModalOpened', { target });
                    }
                }
            });
        });
    }

    // Share functionality between order it again and see similar modal.
    _openModalFromTrigger (url, $trigger, options = {}) {
        const {
            modalClasses = ['cc-orderAgain-modal', 'analytics-order-again'],
            enableOrderAgainInteractions = false,
            afterOpen = null
        } = options;

        $.spinner().start();
        $.ajax(url)
            .then((data) => {
                $.spinner().stop();
                if (!data) {
                    return;
                }

                const onOpen = enableOrderAgainInteractions ? () => this._setOrderAgainModalOpenState(true) : null;
                const onClose = enableOrderAgainInteractions ? () => this._setOrderAgainModalOpenState(false) : null;
                const modal = newModalFromString(data, false, modalClasses, onOpen, onClose);
                $(modal.modalBox).addClass('rightModalAttribute');
                if ($('.page[data-action="OrderAgain-ShowCart"]').length > 0) {
                    $(modal.modalBox).addClass('cc-orderAgain-productPageCartModal');
                }
                // Add dialog semantics for accessibility
                this._setDialogA11y(modal);
                modal.open();
                this._initModalFocus(modal, $trigger);

                if (enableOrderAgainInteractions) {
                    this._addModalListeners(modal);
                    this._addSizePreselection(modal);
                    this._syncInitialUnavailableSizeState(modal);
                }
                this._addModalCloseListener(modal);
                $('body').trigger('seeSimilar:modalOpened');
                // Allow selector-specific behavior once modal is ready
                if (typeof afterOpen === 'function') {
                    afterOpen(modal);
                }
            })
            .fail(() => {
                $.spinner().stop();
            });
    }

    _addModalCloseListener (modal) {
        $(modal.modalBox).find('.js-orderAgain-modal__closeIcon').on('click', () => {
            modal.close();
        });
    }

    _setOrderAgainModalOpenState (isOpen) {
        $('body').toggleClass('cc-orderAgain-modalOpen', !!isOpen);
    }

    _setDialogA11y (modal) {
        const $box = $(modal.modalBox);
        $box.attr({ role: 'dialog', 'aria-modal': 'true' });
        const $title = $box.find('h2').first();
        if ($title.length) {
            if (!$title.attr('id')) {
                this.modalTitleCounter += 1;
                $title.attr('id', `${this.modalTitleIdPrefix}-${this.modalTitleCounter}`);
            }
            $box.attr('aria-labelledby', $title.attr('id'));
        }
    }

    _initModalFocus (modal, $trigger) {
        // Blur the element that opened the modal (so focus leaves carousel context)
        if ($trigger && $trigger.length) {
            $trigger.blur();
        }

        const $close = $(modal.modalBox).find('.js-orderAgain-modal__closeIcon');
        const focusClose = () => {
            if ($close.length) {
                $close[0].focus({ preventScroll: true });
            }
        };

        // Small delay to cover modal animation timing
        const raf = window.raf || window.requestAnimationFrame;
        if (typeof raf === 'function') {
            raf(focusClose);
        } else {
            setTimeout(focusClose, 100);
        }
        this._enableModalFocusTrap(modal, $trigger);
    }

    _enableModalFocusTrap (modal, $trigger) {
        const selector =
            'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';
        const $modalBox = $(modal.modalBox);

        const keydownHandler = (e) => {
            if (e.key === 'Escape') {
                e.preventDefault();
                modal.close();
                $modalBox.off('keydown.orderAgainFocusTrap');
                if ($trigger && $trigger.length) {
                    $trigger[0].focus({ preventScroll: true });
                }
                return;
            }
            if (e.key !== 'Tab') return;

            const $focusables = $modalBox.find(selector).filter(':visible');
            if (!$focusables.length) return;

            const first = $focusables.get(0);
            const last = $focusables.get($focusables.length - 1);
            const active = document.activeElement;

            // Shift + Tab on first -> go to last
            if (e.shiftKey && active === first) {
                e.preventDefault();
                last.focus();
            } else if (!e.shiftKey && active === last) {
                e.preventDefault();
                first.focus();
            }
        };
        $modalBox.on('keydown.orderAgainFocusTrap', keydownHandler);

        $modalBox.find('.js-orderAgain-modal__closeIcon').one('click', () => {
            $modalBox.off('keydown.orderAgainFocusTrap');
            if ($trigger && $trigger.length) {
                $trigger[0].focus({ preventScroll: true });
            }
        });
    }

    _initOrderItAgainCarousel () {
        const $containers = $(this.orderAgainCarouselContainerSelector);
        if ($containers.length === 0) {
            return;
        }

        // Check the carousel mode and reinitialize if needed on window resize
        this._setupCarouselResizeMonitor();

        $containers.each((i, el) => {
            const $container = $(el);
            const isMobileMode = this._getCarouselMode() === 'mobile';
            const $wrapper = $container.closest(this.classCarousel);
            $wrapper.addClass('cc-orderAgain-carousel_show');

            const $prev = $wrapper.find(this.customPrevSelector);
            const $next = $wrapper.find(this.customNextSelector);

            if (isMobileMode) {
                if ($container.hasClass('slick-initialized')) {
                    $container.slick('unslick');
                }

                this._setupNativeScrollMode($container, $prev, $next);
                this._updateNativeArrowState($container, $prev, $next);
                return;
            }

            if ($container.hasClass('slick-initialized')) {
                $container.slick('unslick');
            }

            const $carousel = $container.slick({
                slidesToShow: 6.7,
                slidesToScroll: 1,
                autoplay: false,
                dots: false,
                arrows: false,
                draggable: false,
                swipe: false,
                touchMove: false,
                swipeToSlide: false,
                infinite: false,
                responsive: [
                    {
                        // Large tablet: allow partial drag if desired
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 6.7,
                            swipe: true,
                            draggable: true,
                            touchMove: true,
                            swipeToSlide: true,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 6.7,
                            swipe: true,
                            draggable: true,
                            touchMove: true,
                            swipeToSlide: true,
                        },
                    },
                    {
                        breakpoint: 480,
                        settings: 'unslick'
                    },
                ],
            });

            const updateButtonStates = () => {
                if (!$container.hasClass('slick-initialized')) {
                    return;
                }
                const current = $carousel.slick('slickCurrentSlide');
                const slickInstance = $carousel.slick('getSlick');
                const totalSlides = slickInstance.slideCount;
                const shown = slickInstance.options.slidesToShow;
                const fractional = shown % 1 !== 0;
                // For fractional values (e.g. 4.7) treat visible count as floor(shown)
                // so we allow at least one advance when totalSlides == ceil(shown).
                const effectiveShown = fractional ? Math.floor(shown) : shown;
                let maxIndexBeforeDisable = totalSlides - effectiveShown;
                if (maxIndexBeforeDisable < 0) {
                    maxIndexBeforeDisable = 0;
                }
                $prev.prop('disabled', current <= 0);
                $next.prop('disabled', current >= maxIndexBeforeDisable);
                const bothDisabled = $prev.prop('disabled') && $next.prop('disabled');
                const $controls = $wrapper.find('.cc-orderAgain-carousel__controls');
                $controls.toggleClass('hide', bothDisabled).attr('aria-hidden', bothDisabled ? 'true' : 'false');
            };

            $prev.off('click.orderAgain').on('click.orderAgain', () => {
                $carousel.slick('slickPrev');
                updateButtonStates();
                $('body').trigger('orderAgain:carouselLoaded');
            });
            $next.off('click.orderAgain').on('click.orderAgain', () => {
                $carousel.slick('slickNext');
                updateButtonStates();
                $('body').trigger('orderAgain:carouselLoaded');
            });

            $carousel.on('afterChange', updateButtonStates);
            updateButtonStates();

            // Ensure desktop uses slick-only controls.
            this._disableNativeScrollMode($container, $prev, $next);
        });

        $('body').trigger('listing:orderAgainItems', {
            container: '.js-orderAgain-carousel',
            type: 'buy_it_again'
        });
    }

    // Native scroll for mobile carousel under 480px breakpoint
    _getCarouselMode () {
        return window.matchMedia('(max-width: 479px)').matches ? 'mobile' : 'desktop';
    }

    // Carousel size query parameter on resize (7 on Desktop, 5 on Mobile below 480px)
    _getCarouselSize () {
        return this._getCarouselMode() === 'mobile' ? 5 : 7;
    }

    // Add event listeners for native scroll mode and initialize state
    _getCarouselUrlWithSize (url) {
        try {
            const parsedUrl = new URL(url, window.location.origin);
            parsedUrl.searchParams.set('size', this._getCarouselSize());
            return parsedUrl.pathname + parsedUrl.search + parsedUrl.hash;
        } catch (e) {
            return url;
        }
    }

    _reinitCarouselOnResize () {
        const nextScreenSize = this._getCarouselMode();
        if (this.carouselMode === nextScreenSize) {
            return;
        }

        this.carouselMode = nextScreenSize;

        const $carouselContainer = this._getCarouselContainer();
        const carouselUrl = this.carouselDataUrl || $(this.className).data('url');
        if (carouselUrl && $carouselContainer.length) {
            this._loadCarouselOnViewportChange(carouselUrl, $carouselContainer);
            return;
        }

        this._initOrderItAgainCarousel();
    }

    // Load carousel when specific viewport changes to the correct carousel size
    _loadCarouselOnViewportChange (carouselUrl, $carouselContainer) {
        if (!carouselUrl || !$carouselContainer || !$carouselContainer.length) {
            return;
        }

        const carouselUrlWithSize = this._getCarouselUrlWithSize(carouselUrl);
        this.loadCarousel(carouselUrlWithSize, $carouselContainer);
    }

    _getCarouselContainer () {
        const $container = $(this.viewportCarouselContainerSelector).first();
        if ($container.length) {
            return $container;
        }

        return $(this.classCarousel).first();
    }

    _setupCarouselResizeMonitor () {
        if (this.carouselMode === null) {
            this.carouselMode = this._getCarouselMode();
        }

        if (this.carouselResizeMonitorInitialized) {
            return;
        }

        this.carouselResizeMonitorInitialized = true;
        $(window)
            .off('resize.orderAgainCarouselMode')
            .on('resize.orderAgainCarouselMode', () => {
                clearTimeout(this.carouselResizeTimer);
                this.carouselResizeTimer = setTimeout(() => {
                    this._reinitCarouselOnResize();
                }, 200);
            });
    }

    // Keep native scroll implementation only on mobile carousel
    _separateScrollCarouselState ($carouselContainer) {
        if (!$carouselContainer || !$carouselContainer.length) {
            return;
        }

        const $containers = $carouselContainer.find(this.orderAgainCarouselContainerSelector);
        $containers.each((i, el) => {
            const $container = $(el);
            if ($container.hasClass('slick-initialized')) {
                $container.slick('unslick');
            }
        });

        this._disableNativeScrollMode(this.$nativeCarouselContainer, this.$nativePrevArrow, this.$nativeNextArrow);
    }

    _toggleCarouselControls ($carouselContainer, isHidden) {
        const $wrapper = $carouselContainer.closest(this.classCarousel);
        const $controls = $wrapper.find('.cc-orderAgain-carousel__controls');
        $controls.toggleClass('hide', !!isHidden).attr('aria-hidden', isHidden ? 'true' : 'false');
    }

    _addSizePreselection (modal) {
        const preselectedSize = $(modal.modalBox).find(this.classAddToCartButton).data('purchased-size') || null;
        if (preselectedSize) {
            const $preselectedSizeOption = $(modal.modalBox).find(`${this.classModalSizes}[data-attr-value="${preselectedSize}"]`);
            if ($preselectedSizeOption.length && $preselectedSizeOption.hasClass('selectable')) {
                $preselectedSizeOption.trigger('click');
            }
        }
    }

    _syncInitialUnavailableSizeState (modal) {
        const $selectedUnavailableSize = $(modal.modalBox)
            .find(`${this.classModalSizes}.cc-orderAgain-modal__sizeOption-link--selected.unselectable`)
            .first();

        if (!$selectedUnavailableSize.length) {
            return;
        }

        $(modal.modalBox).find('[data-product-attr="sizeUnavailable"]').removeClass('hide');
        $(modal.modalBox).find('[data-product-attr="colorContainerSizeUnavailable"]').addClass('cc-orderAgain-modal__withSizeUnavailable');
        $selectedUnavailableSize.find('.js-orderAgain-modal__sizeOption-unavailableIcon').removeClass('hide');

        $(modal.modalBox).find('[data-product-attr="addToCartButton"]')
            .toggleClass('disabled', true)
            .prop('disabled', true);
    }

    _addModalListeners (modal) {
        const _self = this;

        // Modal close
        $(modal.modalBox).find('.js-orderAgain-modal__closeIcon').on('click', () => {
            modal.close();
        });

        // Color and size selection event listener
        $(modal.modalBox).on('click', `${this.classModalColors}, ${this.classModalSizes}`, (e) => {
            if ($(e.currentTarget).hasClass('js-orderAgain-modal__viewAllColors')) {
                e.preventDefault();
                _self._toggleModalColorSwatches(modal);
                return;
            }
            e.preventDefault();

            const isSizeSelection = $(e.currentTarget).data('product-attr') === 'size';
            const isUnavailableSize = isSizeSelection && $(e.currentTarget).hasClass('unselectable');
            if (isUnavailableSize) {
                // Notify me management
                const $notifyMeContainer = $(modal.modalBox).find('.js-orderAgain-modal__sizeOptions');
                const isNotifyMeEnabled = $notifyMeContainer.data('is-notify-me-enabled');
                if (!isNotifyMeEnabled) {
                    return;
                }
                const notifyMeUrl = $notifyMeContainer.data('notify-me-url');
                const $currentTarget = $(e.currentTarget);
                return _self._showNotifyMeModal($currentTarget, notifyMeUrl, modal);
            }

            const url = $(e.currentTarget).data('url');
            if (!url) {
                return;
            }

            const productVariationUrl = appendToUrl(url, {
                isOrderAgainProduct: true
            });

            $.spinner().start();
            $.ajax(productVariationUrl).then((data) => {
                $.spinner().stop();

                const product = data.product;
                _self._updateModalGeneralInfo(modal, product, isSizeSelection);

                // Update variation attributes
                for (let i = 0; i < product.variationAttributes.length; i++) {
                    let attr = product.variationAttributes[i];
                    if (attr.swatchable) {
                        _self._updateModalColorSwatches(modal, attr);
                    } else {
                        _self._updateModalSizeOptions(modal, product, attr);
                    }
                }
            }).fail(() => {
                $.spinner().stop();
            });
        });

        // Quantity change listener
        $(modal.modalBox).on('click', `${this.classQuantityInput} .js-quantity-button`, (e) => {
            e.preventDefault();
            e.stopPropagation();

            const $button = $(e.currentTarget);
            const $quantityContainer = $button.closest(this.classQuantityInput);
            const $quantitySelectInput = $quantityContainer.find('select[name="quantity"]');
            const action = $button.attr('data-action');
            const currentQuantity = parseInt($quantitySelectInput.val()) || 1;

            let newQuantity = null;
            if (action === 'increase') {
                newQuantity = currentQuantity + 1;
            } else if (action === 'decrease' && currentQuantity > 1) {
                newQuantity = currentQuantity - 1;
            } else {
                return;
            }

            _self._updateQuantity($quantityContainer, $quantitySelectInput, newQuantity);
        });

        // Add to cart
        $(modal.modalBox).on('click', this.classAddToCartButton, (e) => {
            e.preventDefault();
            const url = $(e.currentTarget).data('url');
            if (!url) {
                return;
            }

            const pid = $(e.currentTarget).data('pid');
            if (!pid) {
                return;
            }

            const currentQuantity = parseInt($(`${this.classQuantityInput} select[name="quantity"]`).val()) || 1;
            const itemListId = $('.page').data('action') === 'OrderAgain-ShowCart' ? 'shopping_bag' : 'my_orders_and_returns';
            const position = parseInt($(e.currentTarget).data('position')) || 0;
            const form = {
                pid: pid,
                quantity: currentQuantity,
                isOrderAgainProduct: true,
                GTMItemListName: 'buy_it_again',
                GTMItemListId: itemListId,
                GTMIndex: position
            };

            const $productContainer = $(modal.modal);
            const $analyticsContainer = $(modal.modalBox).find('.analytics.productListingItem').data();
            const currentPageAction = $('.page').data('action');
            const isCartTabBuyAgainPage = currentPageAction === 'OrderAgain-ShowCart';

            $.spinner().start();
            $.ajax({
                url: url,
                method: 'POST',
                data: form,
                success: data => {
                    $.spinner().stop();
                    if (!data.error) {
                        if (modal && modal.modal) {
                            modal.close();
                        }
                        // Redirect to cart tab when adding from buy again page
                        if (isCartTabBuyAgainPage) {
                            const cartShowUrlFromModal = $(e.currentTarget).data('cart-show-url');
                            const cartShowUrlFromTab = $(this.classCartTab)
                                .find('.cc-orderAgain-cartTab__item[data-analytic-name="cart"] .cc-orderAgain-cartTab__link')
                                .attr('href');
                            const currentHref = window.location.href;
                            const cartShowUrlFromPath = currentHref.replace('OrderAgain-ShowCart', 'Cart-Show');
                            const redirectUrl = cartShowUrlFromModal
                                || cartShowUrlFromTab
                                || (cartShowUrlFromPath !== currentHref ? cartShowUrlFromPath : null);

                            if (redirectUrl) {
                                window.location.href = redirectUrl;
                            }
                        } else {
                            $('.minicart').trigger('count:update', data);
                        }
                        $('body').trigger('product:afterAddToCart', {
                            ...data,
                            form,
                            listingType: 'buy_it_again',
                            $productContainer,
                            $analyticsContainer
                        });
                    }
                },
                error: () => {
                    $.spinner().stop();
                }
            });
        });
    }

    _toggleModalColorSwatches (modal) {
        const $modalBox = $(modal.modalBox);
        const $toggle = $modalBox.find('.js-orderAgain-modal__viewAllColors').first();
        const $extraColors = $modalBox.find('.js-orderAgain-modal__extraColors');

        if (!$toggle.length || !$extraColors.length) {
            return;
        }

        const isExpanded = $toggle.attr('aria-expanded') === 'true';
        const $toggleLabel = $toggle.find('.js-orderAgain-modal__colorSwatch-toggleLabel');
        const $toggleSwatch = $toggle.closest('[data-product-attr="colorToggle"]');
        const currentLabel = $toggleLabel.text();
        const expandedLabel = $toggle.data('expanded-label') || currentLabel;
        const collapsedLabel = $toggle.data('collapsed-label') || currentLabel;
        const nextLabel = isExpanded ? collapsedLabel : expandedLabel;

        $extraColors.toggleClass('hide', isExpanded);
        $toggle.attr('aria-expanded', isExpanded ? 'false' : 'true');
        $toggle.attr('aria-label', nextLabel);
        $toggleSwatch.toggleClass('cc-orderAgain-modal__colorSwatch--empty', !isExpanded);

        if ($toggleLabel.length) {
            $toggleLabel.text(nextLabel);
        }
    }

    _updateModalGeneralInfo (modal, product, isSizeSelection) {
        if (!isSizeSelection) {
            // Update image
            if (product.images.medium && product.images.medium.length > 0) {
                $(modal.modalBox)
                    .find('[data-product-attr="image"]')
                    .attr('src', product.images.medium[0].url);
            }
        }

        // Update product id
        $(modal.modalBox).find('[data-product-attr="pid"]').text(product.id);

        // Update product url
        $(modal.modalBox)
            .find('[data-product-attr="url"]')
            .attr('href', product.productDetailsUrl);

        // Update product ID to add to cart button
        $(modal.modalBox)
            .find('[data-product-attr="addToCartButton"]')
            .data('pid', product.id)
            .attr('data-pid', product.id);

        // Toggle product promotions callout
        $(modal.modalBox)
            .find('[data-product-attr="promotions"]')
            .toggleClass('hide', (product.isSoldout || product.comingSoon || !product.promotions || product.promotions.length === 0));

        // Update product promotions callout message
        if (product.promotions && product.promotions.length > 0) {
            let promotionContainer = '';
            for (let i = 0; i < product.promotions.length; i++) {
                let promotion = product.promotions[i];
                if (promotion && promotion.name) {
                    promotionContainer += applyRendering('orderAgainModalPromotions', {
                        promotionName: promotion.name
                    });
                }
            }
            $(modal.modalBox).find('[data-product-attr="promotions"]')
                .empty()
                .html(promotionContainer);
        }

        // Update product returned label
        const displayReturnedProductLabel = product.orderAgainData && product.orderAgainData.returned;
        $(modal.modalBox)
            .find('[data-product-attr="returnedProductLabel"]')
            .toggleClass('hide', !displayReturnedProductLabel);
    }

    _updateModalColorSwatches (modal, attr) {
        for (let j = 0; j < attr.values.length; j++) {
            let attrValue = attr.values[j];

            // Update selected color label
            if (attrValue.selected) {
                $(modal.modalBox)
                    .find(`[data-product-attr="selectedColor"]`)
                    .text(`${attrValue.value + ' - ' + attrValue.displayValue}`);
            }

            // Update current color swatch selection
            const $swatchWrapper = $(modal.modalBox)
                .find(`[data-product-attr="color"][data-attr-value="${attrValue.value}"]`);

            // Update current color swatch selection + ARIA state
            $swatchWrapper
                .toggleClass('cc-orderAgain-modal__colorSwatch--selected', attrValue.selected)
                .attr('aria-selected', attrValue.selected ? 'true' : 'false')
                .attr('aria-disabled', (attrValue.selectable || attrValue.isSoldout || false) ? 'false' : 'true');

            // Update selectable color swatches + link ARIA + roving tabindex
            const $link = $swatchWrapper.find('.js-orderAgain-modal__colorSwatch-link');
            $link.toggleClass('selectable', (attrValue.selectable || attrValue.isSoldout || false))
                .attr('aria-selected', attrValue.selected ? 'true' : 'false')
                .attr('aria-disabled', attrValue.selectable && !attrValue.isSoldout ? 'false' : 'true')
                .attr('tabindex', attrValue.selected ? '0' : '-1');

            $link.data('url', attrValue.variationUrl || '')
                .attr('data-url', attrValue.variationUrl || '');
        }
    }

    _updateModalSizeOptions (modal, product, attr) {
        let isSizeSelected = false;

        // Reset size unavailable label
        $(modal.modalBox).find('[data-product-attr="sizeUnavailable"]').addClass('hide');
        $(modal.modalBox).find('[data-product-attr="colorContainerSizeUnavailable"]').removeClass('cc-orderAgain-modal__withSizeUnavailable');

        for (let j = 0; j < attr.values.length; j++) {
            let attrValue = attr.values[j];

            // Update selected size label
            if (attrValue.selected) {
                $(modal.modalBox)
                    .find(`[data-product-attr="selectedSize"]`)
                    .text(attrValue.displayValue);
                isSizeSelected = attrValue.selectable;

                // Show size unavailable label
                if (!isSizeSelected && product.orderAgainData && product.orderAgainData.unavailableSizeMessage) {
                    $(modal.modalBox).find('.js-orderAgain-modal__sizeUnavailable-message').text(product.orderAgainData.unavailableSizeMessage);
                    $(modal.modalBox).find('[data-product-attr="sizeUnavailable"]').removeClass('hide');
                    $(modal.modalBox).find('[data-product-attr="colorContainerSizeUnavailable"]').addClass('cc-orderAgain-modal__withSizeUnavailable');
                }
            }

            let sizeValue = attrValue.value.replace(/\//g, '\\/');
            let $sizeElement = $(modal.modalBox).find(`[data-product-attr="size"][data-attr-value="${sizeValue}"]`);

            // Update current size option selection
            $sizeElement.toggleClass('cc-orderAgain-modal__sizeOption-link--selected', attrValue.selected && attrValue.selectable);

            // Update size options url
            $sizeElement.data('url', attrValue.variationUrl || '').attr('data-url', attrValue.variationUrl || '');

            // Update selectable size options
            $sizeElement.toggleClass('selectable', attrValue.selectable);

            // Update unselectable class
            $sizeElement.toggleClass('unselectable', !attrValue.selectable);

            // Update notify me bell visibility
            $sizeElement.find('.js-orderAgain-modal__sizeOption-unavailableIcon').toggleClass('hide', attrValue.selectable);

            // Update hide class for disabled sizes
            $sizeElement.closest('.js-orderAgain-modal__sizeOption').toggleClass('hide', attrValue.disabled || false);
        }

        // Toggle button disabled state
        $(modal.modalBox).find('[data-product-attr="addToCartButton"]')
            .toggleClass('disabled', !isSizeSelected)
            .prop('disabled', !isSizeSelected);
    }

    _showNotifyMeModal ($currentTarget, notifyMeUrl, modal) {
        if (!$currentTarget || !notifyMeUrl) {
            return;
        }

        const variationUrl = $currentTarget.data('url');
        if (!variationUrl) {
            return;
        }

        const params = variationUrl.split('?')[1] || '';
        notifyMeUrl += '?' + params;

        const selectedSize = $currentTarget.data('attr-value') || '';
        notifyMeUrl = appendToUrl(notifyMeUrl, {
            selectedSize: selectedSize
        });

        const _self = this;
        $.spinner().start();
        $.ajax(notifyMeUrl)
            .then((data) => {
                $.spinner().stop();
                if (!data) {
                    return;
                }

                const onNotifyMeModalClose = () => {
                    if (_self.isNotifyMeFlowCompleted) {
                        modal.destroy();
                    } else {
                        $(modal.modal).show();
                    }
                };
                const notifyMeModal = newModalFromString(data, false, ['cc-notifyMe-modal', 'cc-orderAgain-notifyMe-modal'], null, onNotifyMeModalClose);
                _self.isNotifyMeFlowCompleted = false;
                _self._initNotifyMeModal(notifyMeModal);
                Plugins.init();

                if ($(notifyMeModal.modalBox).find('.js-find-in-store-btn-notify-me').length && !_self.findInStoreInitialized) {
                    FindInStore.run(false);
                    _self.findInStoreInitialized = true;
                }

                $(notifyMeModal.modalBox).addClass('rightModalAttribute');

                if ($('.page').data('action') !== 'Product-Show') {
                    $(notifyMeModal.modalBox).addClass(
                        'cc-hide-findInStoreButton'
                    );
                }

                $(modal.modal).hide();
                notifyMeModal.open();

                $(notifyMeModal.modalBox).find('.js-notifyMeModal-close, .js-notifyMe-modal__footerButton').on('click', () => {
                    notifyMeModal.close();
                });
            })
            .catch((error) => {
                $.spinner().stop();
                console.error('Error loading notify me modal:', error);
            });
    }

    _initNotifyMeModal (modal) {
        const _self = this;

        $(modal.modalBox).on('submit', '.js-notifyMe-modal__form', (e) => {
            e.preventDefault();

            const url = $(e.currentTarget).attr('action');
            if (!url) {
                return;
            }

            const form = $(e.currentTarget).serialize();
            const isComingSoon = $(modal.modalBox).find('[name="type"]').val() === 'coming-soon';

            let productName = $('.analytics.productListingItem.hidden').attr('data-item_name') || '';
            let analyticsSku = $('div.notifyMeModal').data('master-pid') || '';
            analyticsSku = getFormatSku(analyticsSku);
            analyticsSku = analyticsSku.match(/_/g) && analyticsSku.match(/_/g).length === 2 ? analyticsSku.substring(0, analyticsSku.lastIndexOf('_')) : analyticsSku; // Removing size
            productName = productName.replace(/\s\s+/g, ' ').split(' ').join('_');

            $.spinner().start();
            $.ajax({
                url: url,
                method: 'POST',
                data: form
            }).then((data) => {
                $.spinner().stop();
                if (data.success) {
                    $('.js-notifyMeModal-toHide').addClass('hidden');
                    if (isComingSoon) {
                        $('#messageGreen').addClass('hidden');
                        $('#comingSoonGreen').removeClass('hidden');
                    }
                    $('#comingSoonGreen').text(data.messageComingSoon);
                    $('#messageGreen').text(data.message);
                    $('.js-notifyMeModal-toShow').removeClass('hidden');
                    $('.js-notifyMeModal-notifyBtn').addClass('hidden');
                    $('.js-notifyMeModal-titleNotComingSoon,.js-notifyMeModal-titleComingSoon').addClass('hidden');
                    $('.js-notifyMeModal-subTitleNotComingSoon, .js-notifyMeModal-subTitleComingSoon').addClass('hidden');
                    $('.continueShopping').removeClass('hidden');
                    $('.js-notifyMeModal-emailError').addClass('hidden');
                    $('.js-notifyMeModal-duplicateError').addClass('hidden');
                    if (!Foundation.MediaQuery.atLeast('medium')) {
                        $('.subtitleHide').addClass('hidden');
                    }

                    $('body').trigger('soldout:notify', {
                        size: $('.sizeNotify').text().trim(),
                        productName: productName,
                        sku: analyticsSku,
                        availability: 'product_notify_me',
                    });
                } else {
                    if (data.duplicate) {
                        $('.js-notifyMeModal-duplicateError').removeClass('hidden');
                    }
                }
                _self.isNotifyMeFlowCompleted = true;
            }).catch(() => {
                $.spinner().stop();
            });
        });
    }

    _updateQuantity ($quantityContainer, $quantitySelectInput, newQuantity) {
        const url = $quantitySelectInput.find('option[value="' + newQuantity + '"]').data('url');
        if (!url) {
            return;
        }

        $.spinner().start();
        $.ajax(url).then((data) => {
            $.spinner().stop();
            if (!data || !data.product) {
                return;
            }

            // Update displayed quantity label
            $quantityContainer.find('.js-quantity-value').text(newQuantity);

            // Update hidden select input
            if (data.product.quantities) {
                const optionsHtml = data.product.quantities.map((quantity) => {
                    const selected = quantity.selected ? 'selected' : '';
                    return `<option value="${quantity.value}" data-url="${quantity.url}" ${selected}>${quantity.value}</option>`;
                }).join('');
                $quantitySelectInput.empty().html(optionsHtml);
            }

            // Quantity threshold check to disable buttons
            if (newQuantity === 1) {
                $quantityContainer.find('.js-quantity-button[data-action="decrease"]').addClass('disabled');
            } else if (newQuantity === 10) {
                $quantityContainer.find('.js-quantity-button[data-action="increase"]').addClass('disabled');
            } else {
                $quantityContainer.find('.js-quantity-button').removeClass('disabled');
            }
        });
    }

    // Native Scroll Mode Methods for mobile carousel
    _setupNativeScrollMode ($carouselContainer, $prevArrow, $nextArrow) {
        if (!($carouselContainer && $carouselContainer.length)) {
            return;
        }

        this.$nativeCarouselContainer = $carouselContainer;
        this.$nativePrevArrow = $prevArrow;
        this.$nativeNextArrow = $nextArrow;

        if (!this._evaluateNativeMode) {
            this._evaluateNativeMode = () => {
                if (!this.$nativeCarouselContainer || !this.$nativeCarouselContainer.length) {
                    return;
                }
                const isSlickInitialized = this.$nativeCarouselContainer.hasClass('slick-initialized');
                if (!isSlickInitialized) {
                    this._enableNativeScrollMode(this.$nativeCarouselContainer, this.$nativePrevArrow, this.$nativeNextArrow);
                } else {
                    this._disableNativeScrollMode(this.$nativeCarouselContainer, this.$nativePrevArrow, this.$nativeNextArrow);
                }
            };
        }

        this._evaluateNativeMode();
        setTimeout(() => {
            this._evaluateNativeMode();
        }, 0);

        if (!this.nativeScrollMonitorInitialized) {
            this.nativeScrollMonitorInitialized = true;
            $(window)
                .off(`resize${this.nativeScrollClass}`)
                .on(`resize${this.nativeScrollClass}`, () => {
                    clearTimeout(this.nativeScrollResizeTimer);
                    this.nativeScrollResizeTimer = setTimeout(() => {
                        this._evaluateNativeMode();
                    }, 200);
                });
        }
    }

    _enableNativeScrollMode ($carouselContainer, $prevArrow, $nextArrow) {
        if (!($carouselContainer && $carouselContainer.length && $prevArrow && $prevArrow.length && $nextArrow && $nextArrow.length)) {
            return;
        }

        if (this.nativeScrollActive) {
            this._updateNativeArrowState($carouselContainer, $prevArrow, $nextArrow);
            return;
        }

        this.nativeScrollActive = true;
        $carouselContainer.addClass('cc-orderAgain-carousel__container--nativeScroll');

        this._nativePrevHandler = (e) => {
            e.preventDefault();
            this._scrollNativeCarousel($carouselContainer, 'prev');
        };
        this._nativeNextHandler = (e) => {
            e.preventDefault();
            this._scrollNativeCarousel($carouselContainer, 'next');
        };

        $prevArrow.on(`click${this.nativeScrollClass}`, this._nativePrevHandler);
        $nextArrow.on(`click${this.nativeScrollClass}`, this._nativeNextHandler);
        this._nativeScrollHandler = throttle(() => {
            this._updateNativeArrowState($carouselContainer, $prevArrow, $nextArrow);
        }, 100);
        $carouselContainer.on(`scroll${this.nativeScrollClass}`, this._nativeScrollHandler);

        this._updateNativeArrowState($carouselContainer, $prevArrow, $nextArrow);
        setTimeout(() => {
            this._updateNativeArrowState($carouselContainer, $prevArrow, $nextArrow);
        }, 100);
    }

    _disableNativeScrollMode ($carouselContainer, $prevArrow, $nextArrow) {
        if (!this.nativeScrollActive) {
            return;
        }

        this.nativeScrollActive = false;
        if ($carouselContainer && $carouselContainer.length) {
            $carouselContainer.removeClass('cc-orderAgain-carousel__container--nativeScroll');
            if (this._nativeScrollHandler) {
                $carouselContainer.off(`scroll${this.nativeScrollClass}`, this._nativeScrollHandler);
            } else {
                $carouselContainer.off(this.nativeScrollClass);
            }
        }
        if ($prevArrow && $prevArrow.length) {
            $prevArrow.off(`click${this.nativeScrollClass}`);
        }
        if ($nextArrow && $nextArrow.length) {
            $nextArrow.off(`click${this.nativeScrollClass}`);
        }
        this._nativePrevHandler = null;
        this._nativeNextHandler = null;
        this._nativeScrollHandler = null;
    }

    _scrollNativeCarousel ($carouselContainer, direction) {
        if (!$carouselContainer || !$carouselContainer.length) {
            return;
        }

        const node = $carouselContainer.get(0);
        if (!node) {
            return;
        }

        const $items = $carouselContainer.find(this.classCarouselItem);
        const $firstItem = $items.first();
        const itemWidth = $firstItem.outerWidth() || 120;
        const itemScroll = (() => {
            if ($items.length > 1) {
                const firstLeft = $items.eq(0).position().left || 0;
                const secondLeft = $items.eq(1).position().left;
                if (typeof secondLeft === 'number') {
                    const pitch = secondLeft - firstLeft;
                    if (pitch > 0) {
                        return pitch;
                    }
                }
            }
            return itemWidth;
        })();
        const maxScroll = Math.max(node.scrollWidth - node.clientWidth, 0);
        const currentScroll = node.scrollLeft;
        const rawIndex = currentScroll / itemScroll;
        const epsilon = 0.01;
        const isAligned = Math.abs(rawIndex - Math.round(rawIndex)) < epsilon;
        let targetIndex;
        if (direction === 'next') {
            targetIndex = isAligned
                ? rawIndex + 1
                : Math.ceil(rawIndex);
            targetIndex = Math.min(targetIndex, Math.ceil(maxScroll / itemScroll));
        } else {
            targetIndex = isAligned
                ? rawIndex - 1
                : Math.floor(rawIndex);
            targetIndex = Math.max(targetIndex, 0);
        }

        const targetScroll = Math.min(Math.max(targetIndex * itemScroll, 0), maxScroll);

        if (typeof node.scrollTo === 'function') {
            node.scrollTo({
                left: targetScroll,
                behavior: 'smooth'
            });
        } else {
            node.scrollLeft = targetScroll;
        }

        setTimeout(() => {
            this._updateNativeArrowState($carouselContainer, this.$nativePrevArrow, this.$nativeNextArrow);
        }, 250);
    }

    _updateNativeArrowState ($carouselContainer, $prevArrow, $nextArrow) {
        if (!($carouselContainer && $carouselContainer.length && $prevArrow && $prevArrow.length && $nextArrow && $nextArrow.length)) {
            return;
        }

        const node = $carouselContainer.get(0);
        if (!node) {
            return;
        }

        const maxScroll = Math.max(node.scrollWidth - node.clientWidth, 0);
        const scrollLeft = node.scrollLeft;
        const isAtStart = scrollLeft <= 1;
        const isAtEnd = maxScroll === 0 || scrollLeft >= (maxScroll - 1);
        const bothDisabled = isAtStart && isAtEnd;

        $prevArrow.prop('disabled', isAtStart);
        $nextArrow.prop('disabled', isAtEnd);
        this._toggleCarouselControls($carouselContainer, bothDisabled);
    }

    loadOrderDetailsButtons (url, $orderDetailsItems) {
        const products = [];
        $orderDetailsItems.each((index, element) => {
            products.push({
                pid: String($(element).data('pid')) || '',
                uuid: String($(element).data('uuid')) || ''
            });
        });

        $.ajax({
            url: url,
            method: 'POST',
            data: {
                data: JSON.stringify(products)
            },
            success: (data) => {
                if (!data || !data.result) {
                    return;
                }
                for (let i = 0; i < data.result.length; i++) {
                    let result = data.result[i];
                    const $itemContainer = $(`${this.classOrderDetailsItem}[data-uuid="${result.uuid}"]`);
                    const $itemContainerMobile = $(`${this.classOrderDetailsItemMobile}[data-uuid="${result.uuid}"]`);
                    $itemContainer.html('').append(result.html || '');
                    $itemContainerMobile.html('').append(result.html || '');
                }
            }
        });
    }

    orderAgainPageListeners () {
        const _self = this;
        // Radio buttons listener (dropdown with radio buttons behaviour)
        $('body').on('change', 'input[name="orderAgainFilter"]', (e) => {
            e.preventDefault();

            const $radio = $(e.currentTarget);
            const url = $radio.data('url');
            if (!url) {
                return;
            }

            const $endContainer = $('.js-orderAgain-page__endContainer');
            if (!$endContainer.length) return;
            const currentListStartValue = (parseInt($endContainer.data('start-value'), 10) || 0);
            const currentListSizeValue = (parseInt($endContainer.data('size-value'), 10) || 0);
            const applyFilterUrl = appendToUrl(url, {
                start: 0,
                size: currentListStartValue + currentListSizeValue
            });

            $.spinner().start();
            $.ajax(applyFilterUrl).then((data) => {
                $.spinner().stop();
                if (!data) return;

                $(_self.classProductsContainer).html(data.html || '');
                $('.js-orderAgain-page__viewAllProductsNumber').text(data.totalProductsLabel || '');

                const labelText = $radio.closest('label').find('.radio-label').text().trim();
                const $filterSelect = $('.js-orderAgain-filter__select');
                const $selectedLabel = $filterSelect.find('.js-orderAgain-selectedLabel');
                const $prefix = $filterSelect.find('.cc-orderAgain-page__filtersTitlePrefix');
                // Always show the selected label and hide the prefix
                $selectedLabel.text(labelText).removeClass('hidden');
                $prefix.addClass('hidden');

                // Sync the checked state back to the page filter
                const selectedValue = $radio.val();
                const $pageFilter = $('.js-orderAgain-filter__select');
                $pageFilter.find('input[name="orderAgainFilter"]').prop('checked', false).removeAttr('checked');
                $pageFilter.find(`input[name="orderAgainFilter"]`).filter(function () {
                    return $(this).val() === selectedValue;
                }).prop('checked', true).attr('checked', 'checked');

                // Close modal on mobile after selection
                _self._closeFilterModal();
                if (Foundation.MediaQuery.atLeast('medium')) {
                    _self._closeDesktopFilterDropdown();
                }
            });
        });

        // Toggle filters body visibility on button click
        $('body').on('click', '.cc-orderAgain-page__filtersRadioButton.js-orderAgain-filter__select', function (e) {
            if ($(e.target).closest('.cc-orderAgain-page__filtersBody').length) {
                return;
            }

            const isMobile = !Foundation.MediaQuery.atLeast('medium');

            if (isMobile) {
                // On mobile, open the modal
                e.preventDefault();
                e.stopPropagation();
                _self._openFilterModal();
                return;
            }

            // Desktop dropdown behavior
            const $button = $(this);
            const $filters = $button.find('.cc-orderAgain-page__filtersBody');
            const isOpen = $button.hasClass('cc-orderAgain-page__filtersRadioButton--open');

            const openFiltersDropdown = () => {
                $filters.attr('aria-hidden', 'false');
                // Use requestAnimationFrame to ensure the browser has painted the initial state
                window.requestAnimationFrame(() => {
                    $button.addClass('cc-orderAgain-page__filtersRadioButton--open').attr('aria-expanded', 'true');
                });
            };

            const closeFiltersDropdown = () => {
                $button.removeClass('cc-orderAgain-page__filtersRadioButton--open').attr('aria-expanded', 'false');
                // Wait for animation to complete before setting aria-hidden
                setTimeout(() => {
                    $filters.attr('aria-hidden', 'true');
                }, 200);

                $(document).off('click.orderAgainOutside');
            };

            if (!isOpen) {
                e.stopPropagation();
                openFiltersDropdown();
                $(document).on('click.orderAgainOutside', (event) => {
                    if ($(event.target).closest('.cc-orderAgain-page__filtersRadioButton.js-orderAgain-filter__select').length === 0) {
                        closeFiltersDropdown();
                    }
                });
            } else {
                e.stopPropagation();
                closeFiltersDropdown();
            }
        });
    }

    orderAgainPageInfiniteScroll () {
        const $endContainer = $('.js-orderAgain-page__endContainer');
        if (!$endContainer.length) return;
        let endContainerDistance = $endContainer.offset().top;

        const totalProducts = parseInt($endContainer.data('total-products'), 10);
        const currentStartValue = parseInt($endContainer.data('startValue'), 10);
        const currentSizeValue = parseInt($endContainer.data('sizeValue'), 10);
        let hasMoreProducts = (currentStartValue + currentSizeValue) < totalProducts;
        if (!hasMoreProducts) return;

        let isLoading = false;
        $(window).on('scroll', () => {
            const scrollPosition = $(window).scrollTop() + $(window).height();
            if (!isLoading && hasMoreProducts && scrollPosition >= endContainerDistance) {
                isLoading = true;

                const url = $endContainer.data('url');
                const startValue = parseInt($endContainer.data('startValue'), 10);
                const sizeValue = parseInt($endContainer.data('sizeValue'), 10);
                const newStartValue = startValue + sizeValue;
                const loadMoreUrl = appendToUrl(url, {
                    start: newStartValue,
                    size: sizeValue
                });

                $.spinner().start();
                $.ajax(loadMoreUrl).then((data) => {
                    $.spinner().stop();
                    if (!data) return;

                    $endContainer.before(data);
                    $endContainer
                        .data('start-value', parseInt(newStartValue, 10))
                        .attr('data-start-value', parseInt(newStartValue, 10));
                    endContainerDistance = $endContainer.offset().top;

                    hasMoreProducts = (parseInt(newStartValue, 10) + parseInt(sizeValue, 10)) < parseInt(totalProducts, 10);
                    isLoading = false;
                });
            }
        });
    }

    _openFilterModal () {
        const $filterContent = $('.js-orderAgain-filterModal__overlay');
        if ($filterContent.length && !this.filterModal) {
            const content = $filterContent.html();
            this.filterModal = newModalFromString(content, false, ['cc-orderAgain-filterModal']);
            $(this.filterModal.modalBox).addClass('cc-orderAgain-filterModal__modalBox');

            // Sync checked state from page filter to modal
            const $pageFilter = $('.js-orderAgain-filter__select');
            let $checkedRadio = $pageFilter.find('input[name="orderAgainFilter"]:checked');

            // If no radio is checked on the page, check the first one
            if (!$checkedRadio.length) {
                $checkedRadio = $pageFilter.find('input[name="orderAgainFilter"]').first();
            }

            if ($checkedRadio.length) {
                const checkedValue = $checkedRadio.val();
                const $modalRadios = $(this.filterModal.modalBox).find('input[name="orderAgainFilter"]');

                // Uncheck all radios in modal
                $modalRadios.prop('checked', false).removeAttr('checked');

                // Check the matching radio in modal by value
                const $matchingRadio = $modalRadios.filter(function () {
                    return $(this).val() === checkedValue;
                });

                if ($matchingRadio.length) {
                    $matchingRadio.prop('checked', true).attr('checked', 'checked');
                } else {
                    // Fallback: check first radio if no match found
                    $modalRadios.first().prop('checked', true).attr('checked', 'checked');
                }
            }

            // Add close button listener
            $(this.filterModal.modalBox).find('.js-orderAgain-filterModal__closeIcon').on('click', () => {
                this._closeFilterModal();
            });

            this.filterModal.open();
        } else if (this.filterModal) {
            this.filterModal.open();
        }
    }

    _closeFilterModal () {
        if (this.filterModal) {
            this.filterModal.close();
            this.filterModal = null;
        }
    }

    _closeDesktopFilterDropdown () {
        const $button = $('.cc-orderAgain-page__filtersRadioButton.js-orderAgain-filter__select');
        if (!$button.length) {
            return;
        }
        $button.removeClass('cc-orderAgain-page__filtersRadioButton--open').attr('aria-expanded', 'false');
        setTimeout(() => {
            $button.find('.cc-orderAgain-page__filtersBody').attr('aria-hidden', 'true');
        }, 200);
        $(document).off('click.orderAgainOutside');
    }

    initFilterSelectionLabel () {
        const $container = $('.js-orderAgain-filter__select');
        if (!$container.length) return;
        let $checked = $container.find('input[name="orderAgainFilter"]:checked');
        if (!$checked.length) {
            $checked = $container.find('input[name="orderAgainFilter"]').first();
            $checked.prop('checked', true).attr('checked', 'checked');
        }
        const labelText = $checked.closest('label').find('.radio-label').text().trim();
        const $selectedLabel = $container.find('.js-orderAgain-selectedLabel');
        const $prefix = $container.find('.cc-orderAgain-page__filtersTitlePrefix');

        // Show prefix initially, hide selected label (default state)
        $selectedLabel.text(labelText).addClass('hidden');
        $prefix.removeClass('hidden');
    }

    showCartTab (url) {
        $.ajax(url).then((data) => {
            if (data && data.hasPurchasedProducts && data.hasPurchasedProducts === true) {
                $('.js-orderAgain-cartTab__container').removeClass('hide');
            }
        });
    }

    addProductDetailsListeners ($container, url) {
        this._loadProductDetailsPreviouslyPurchasedSizeLabel($container, url);

        const _self = this;
        $('body').on('orderAgain:previouslyPurchasedSizeUpdate', () => {
            _self._loadProductDetailsPreviouslyPurchasedSizeLabel($container, url);
        });
    }

    _loadProductDetailsPreviouslyPurchasedSizeLabel ($container, url) {
        const pid = $container.data('pid');
        if (!pid) {
            return;
        }

        $.ajax({
            url: url,
            data: {
                pid: pid
            }
        }).then((data) => {
            $container.toggleClass('hidden', !data.previouslyPurchasedSizeLabel).html(data.previouslyPurchasedSizeLabel || '');
        });
    }

    loadRecommendationsCarousel () {
        const $container = $(this.classRecommendations);
        if ($container.length === 0) {
            return;
        }

        const url = $container.data('url');
        if (!url) {
            return;
        }

        $.ajax({
            url: url,
            method: 'GET',
            data: {
                cgid: '',
                sku: '',
                route: 'Cart-Show',
                servingConfig: 'recommended-for-you-ww'
            }
        }).then((data) => {
            if (data) {
                $container.html(data);
                initProductTile();
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const orderAgain = new OrderAgain();
    orderAgain.run();
});
